import React from 'react';
import useTranslate from '../../Hooks/useTranslate';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';
import { useIntl } from 'react-intl';

const CaptionValue = function CaptionValue({
  caption,
  value,
  captionColor = 'textSecondary',
  valueColor = 'textPrimary',
  reverse,
  direction = 'column',
  width,
  height,
  gap = '4px',
  flex,
  padding,
  textAlign,
  captionStyle,
  valueStyle,
  fallback = 'UNAVAILABLE',
  className,
}) {
  const translate = useTranslate();
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        flexDirection: reverse ? `${direction}-reverse` : direction,
        alignItems: direction === 'row' ? 'center' : 'stretch',
        width: width,
        gap: gap,
        height: height,
        flex: flex,
        padding: padding,
      }}
    >
      <Typography
        variant="body2"
        color={captionColor}
        sx={{
          textAlign,
          userSelect: 'none',
          ...captionStyle,
        }}
        noWrap
      >
        {translate(caption)}
      </Typography>
      {typeof value === 'string' ||
      typeof value === 'number' ||
      (!value &&
        (typeof fallback === 'string' || typeof fallback === 'number')) ? (
        <Typography
          variant="body1"
          color={valueColor}
          sx={{
            textAlign,
            userSelect: 'none',
            color: valueColor?.includes('#') ? valueColor : undefined,
            ...valueStyle,
          }}
          noWrap
        >
          {translate(value) || value || translate(fallback)}
        </Typography>
      ) : (
        value || fallback
      )}
    </Box>
  );
};

CaptionValue.propTypes = {
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  captionColor: PropTypes.string,
  valueColor: PropTypes.string,
  reverse: PropTypes.bool,
  direction: PropTypes.oneOf(['row', 'column']),
  width: PropTypes.string,
  height: PropTypes.string,
  gap: PropTypes.string,
  flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.string,
  textAlign: PropTypes.string,
  captionStyle: PropTypes.object,
  valueStyle: PropTypes.object,
  fallback: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};
export default CaptionValue;
